module.exports = __webpack_public_path__ + "img/cherry-turner.1cf62c38.png";